var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row no-gutters flex-fill panel-audit" }, [
    _c(
      "div",
      { staticClass: "col-12" },
      [
        _c(_vm.viewer, {
          tag: "component",
          attrs: {
            panelId: _vm.idPanel,
            translatePrefix: _vm.translatePrefix,
            url: _vm.url,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }